/**
 * Scale factor currently applied to the portal shell (see --app-zoom in
 * index.css), read from the nearest scaled ancestor of `el`.
 *
 * Filter dropdowns portal themselves to document.body to escape the table's
 * overflow clipping, which puts them outside the shell. Once they are scaled too
 * there are two coordinate spaces in play: getBoundingClientRect() on a trigger
 * inside the shell reports real screen px, while a scaled dropdown interprets
 * its own inline top/left/width as design px. Dividing the measured value by
 * this factor converts one to the other.
 *
 * Returns 1 whenever nothing is scaled — below the 1500px breakpoint, on mobile,
 * or when the element is not inside a shell — so the arithmetic is a no-op and
 * callers need no branching.
 */
export const getShellZoom = (el: Element | null | undefined): number => {
  const shell = el?.closest?.(".portal-shell");
  if (!shell) return 1;
  // getPropertyValue rather than `.zoom`: the property is absent from the DOM
  // typings shipped with this TypeScript version.
  const zoom = parseFloat(getComputedStyle(shell).getPropertyValue("zoom"));
  return Number.isFinite(zoom) && zoom > 0 ? zoom : 1;
};
